import styled, { css } from 'styled-components';

const Container = styled.div`
    display: flex;
    align-items: center;
`;

const IconWrap = styled.div`
    height: 24px;
    width: 24px;
    flex: 0 0 auto;
    margin-right: 12px;
    & > * {
      fill: ${({ theme }) => theme.colors.Foreground};
    }
`;

const TextWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    ${({theme}) => css(theme.typography.Paragraph)};
    ${({ theme, tinyText }) => tinyText && css`
        ${css(theme.typography.TinyParagraph)};
    `};
`;

const FreeShipping = styled.p`
    color: green;
    text-transform: uppercase;
    &:before {
        content: " ";
        white-space: pre;
    }
`;

const ShippingDates = styled.p`
    color: ${({ theme }) => theme.colors.Foreground};
    &:before {
        content: " ";
        white-space: pre;
    }
`;

export {
    Container,
    IconWrap,
    TextWrap,
    FreeShipping,
    ShippingDates,
};
